// extracted by mini-css-extract-plugin
export var chatHtmlText = "_s9-2";
export var chatLink = "_s9-0";
export var chatText = "_s9-1";